import Produto from "model/administracao/cadastro/produto/Produto";
import Deposito from "./Deposito";
import Transacao from "./Transacao";
import EstoqueLote from "./EstoqueLote";


export default class AjusteEstoque {
    tipo: string;
    transacao: Transacao;
    deposito: Deposito;
    produto: Produto;
    lote: EstoqueLote;
    quantidade: number|null;
    valorUnitario: number|null;
    observacao: string;
    integrado: boolean;

    constructor( 
        tipo = '',
        transacao = new Transacao(),
        deposito = new Deposito(),
        produto = new Produto(),
        lote = new EstoqueLote(),
        quantidade = 0,
        valorUnitario = 0,
        observacao = '',
        integrado = false
    ) {
        this.tipo = tipo;
        this.transacao = transacao;
        this.deposito = deposito;
        this.produto = produto;
        this.lote = lote;
        this.quantidade = quantidade;
        this.valorUnitario = valorUnitario;
        this.observacao = observacao;
        this.integrado = integrado;
    }

}